import { DefinitionLevels } from 'common/services/settings.service';

export const getFormattedDailyTime = ({
  getTeamOrOrgSetting,
  isOrgSettings,
  selectedTeamId
}) =>
  getTeamOrOrgSetting({
    name: 'dailyTime',
    ...(isOrgSettings
      ? { definitionLevel: DefinitionLevels.ORGANIZATION }
      : { definitionLevel: DefinitionLevels.TEAM, teamId: selectedTeamId })
  });
